<template>
  <avl-modal :is-shown="isShown" :backdrop-disabled="backdropDisabled">
    <div class="p-act">
      <p class="p-act__question">{{ title }}</p>

      <div class="p-act__buttons">
        <el-button
          class="p-act__button p-act__button--success"
          v-if="buttonSuccess"
          type="success"
          :disabled="buttonSuccess.disabled"
          @click.native="buttonSuccess.callback"
        >
          {{ buttonSuccess.label }}
        </el-button>

        <el-button
          class="p-act__button p-act__button--danger"
          v-if="buttonDanger"
          type="danger"
          :disabled="buttonDanger.disabled"
          @click.native="buttonDanger.callback"
        >
          {{ buttonDanger.label }}
        </el-button>
      </div>
    </div>
  </avl-modal>
</template>

<script>
  export default {
    props: {
      isShown: {
        type: Boolean,
        required: true,
      },
      backdropDisabled: {
        type: Boolean,
      },
      title: {
        type: String,
        required: true,
      },
      buttonSuccess: {
        type: Object,
      },
      buttonDanger: {
        type: Object,
      },
    },
  };
</script>

<style scoped lang="scss">
  .p-act {
    text-align: left;

    &__question {
      margin: 0 0 32px;
      font-size: 20px;
    }

    &__buttons {
      display: flex;
      justify-content: space-between;
    }

    &__button {
      display: inline-block;
      vertical-align: middle;
      width: 100%;

      &:first-child {
        margin-right: 8px;
      }

      &:last-child {
        margin: 0;
      }
    }
  }
</style>
